import { ErrorMessage } from 'formik';
import './form-error-message.css';

export function FormErrorMessage({ name }) {
  return <ErrorMessage name={name} component="div" className="form-error-msg" />;
}